import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const VoucherIssueCountSchemas = zod.object({
    voucherId: zod.number(),
    voucherName: zod.string(),
    issueCount: zod.number(),
})

export const VoucherRedemptionCountItemSchemas = zod.object({
    unit: zod.string(),
    voucherId: zod.number(),
    redemptionCount: zod.number(),
})

export const ReportVoucherRedemptionCountCreateFormSchemas = zod.object({
    voucherIds: zod.number().array().nullable(),
    voucherCodes: zod.string().array().nullable(),
    startDate: zod.string().min(1, { message: 'Start date is Required.' }),
    endDate: zod.string().nullable(),
    groupLevel: zod.number(),
})

export const ReportVoucherRedemptionCountAPISchemas = DefaultSchemas.merge(
    zod.object({
        data: zod.object({
            voucherIssueCounts: VoucherIssueCountSchemas.array(),
            voucherRedemptionCounts: VoucherRedemptionCountItemSchemas.array(),
        }),
    })
)

export type ReportVoucherRedemptionCountCreateFormTypes = zod.infer<typeof ReportVoucherRedemptionCountCreateFormSchemas>;
export type VoucherIssueCountTypes = zod.infer<typeof VoucherIssueCountSchemas>;
export type VoucherRedemptionCountItemTypes = zod.infer<typeof VoucherRedemptionCountItemSchemas>;
export type ReportVoucherRedemptionCountAPITypes = zod.infer<typeof ReportVoucherRedemptionCountAPISchemas>;